import React from 'react';
import { XIcon, CheckIcon, ArrowDownIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { beforeItems, afterItems } from '../data/beforeAfter';
export function ProblemSection() {
  return <section className="w-full bg-canvas px-5 py-16 sm:py-20" data-id="element-219" data-mp="30j0unbbjar5q">
      <div className="mx-auto max-w-5xl" data-id="element-220" data-mp="2vpplv4n5w0b6">
        <SectionHeading kicker="The real gap" title={<>
              The problem isn't always a <span className="text-alert-600" data-id="element-222" data-mp="35gty3wlgd72b">lack of knowledge</span>
            </>} data-id="element-221" data-mp="39hvzok2udv7g" />
        <div className="mx-auto mt-8 max-w-2xl space-y-4 text-center text-[17px] leading-relaxed text-muted" data-id="element-223" data-mp="3jglgsamwzbmn">
          <p data-id="element-224" data-mp="3ei0iigr8320u">
            You can have years of automotive experience. You can own professional diagnostic equipment. You can have
            multiple programmers, technical manuals, and hundreds of saved resources.
          </p>
          <p className="font-semibold text-ink" data-id="element-225" data-mp="1k4sjse04m69x">And you can still feel uncertain when an unfamiliar TCM arrives at your workshop.</p>
          <p data-id="element-226" data-mp="oc7xjguomdit">
            Why? Because having information and knowing how to organize your next diagnostic step are two different
            things. That's the gap TCM Diagnostic Blueprint™ was designed to address.
          </p>
        </div>

        <div className="mt-12 grid items-stretch gap-4 md:grid-cols-2 md:gap-6" data-id="element-227" data-mp="x5bhm7zu1omf">
          <div className="flex flex-col rounded-3xl border-2 border-alert-500 bg-white p-6 sm:p-8" data-id="element-228" data-mp="124e9srups0cz">
            <div className="flex items-center gap-3" data-id="element-229" data-mp="171wm8s7xwxpq">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-alert-600" data-id="element-230" data-mp="174it0pn0b96w">
                <XIcon className="h-6 w-6 text-white" strokeWidth={3} aria-hidden="true" data-id="element-231" data-mp="1bzy7njsu994d" />
              </span>
              <h3 className="font-display text-4xl font-black uppercase text-alert-600" data-id="element-232" data-mp="3dt5lspwptkoo">Before</h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-233" data-mp="3hu7lf7ujnyr6">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-[16px] leading-snug text-ink" data-id="element-234" data-mp="p00kvq7g3mz4">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-alert-600" strokeWidth={3} aria-hidden="true" data-id="element-235" data-mp="k15x09umf885" />
                  <span data-id="element-236" data-mp="y1glx7cdecqo">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex justify-center md:hidden" aria-hidden="true" data-id="element-237" data-mp="tyu1vslxxw41">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-navy-900" data-id="element-238" data-mp="17z4tixv2req9">
              <ArrowDownIcon className="h-6 w-6 text-gold-400" strokeWidth={3} data-id="element-239" data-mp="1301nba3cz2gp" />
            </span>
          </div>

          <div className="flex flex-col rounded-3xl bg-navy-900 p-6 text-white sm:p-8" data-id="element-240" data-mp="1hpfymnqhvtyq">
            <div className="flex items-center gap-3" data-id="element-241" data-mp="1cq3cy6bd0sxq">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-cta-500" data-id="element-242" data-mp="1cqd1dpgras1b">
                <CheckIcon className="h-6 w-6 text-navy-950" strokeWidth={3} aria-hidden="true" data-id="element-243" data-mp="1qpvzrqjrmp0f" />
              </span>
              <h3 className="font-display text-4xl font-black uppercase leading-none text-cta-400" data-id="element-244" data-mp="1loor7p9stlsp">
                After
                <span className="block text-base font-bold tracking-wide text-slate-300" data-id="element-245" data-mp="2ab5wrk1vx7rk">With TCM Diagnostic Blueprint™</span>
              </h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-246" data-mp="1wbdduawlnvu5">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-[16px] leading-snug text-slate-100" data-id="element-247" data-mp="20bnh3ft0c85b">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta-400" strokeWidth={3} aria-hidden="true" data-id="element-248" data-mp="1mk8y38z3o6y9" />
                  <span data-id="element-249" data-mp="1rdv3cg2xp8k1">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center text-lg font-semibold leading-relaxed text-ink" data-id="element-250" data-mp="1clt7r87wd1pt">
          The objective isn't to memorize every TCM procedure in existence. It's to have a clear process for deciding
          what information you need and what to investigate next.
        </p>
        <CtaButton label="I want a structured TCM diagnostic system" className="mt-10" data-id="element-251" data-mp="10lczj2pfs7t3" />
      </div>
    </section>;
}